<!-- =========================================================================================
  File Name: TeacherEdit.vue
  Description: Teacher Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-teacher-edit">

    <vs-alert color="danger" title="Teacher Not Found" :active.sync="teacher_not_found">
      <span>Teacher record with id: {{ $route.params.studentID }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-teacher-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <!-- <vx-card v-if="teacher_data"> -->
    <vx-card title="교직원 상세 정보" class="mb-base" v-if="teacher_data">
      <teacher-edit-form class="mt-4" :data="teacher_data" />
    </vx-card>
  </div>
</template>

<script>
import TeacherEditForm  from './TeacherEditForm.vue'
import { fetchData } from '@/api/module'

export default {
  components: {
    TeacherEditForm
  },
  data () {
    return {
      teacher_data: null,
      teacher_not_found: false
    }
  },
  async created () {
    try {
      const teacherID = this.$route.params.teacherID
      const { data } = await fetchData(`teacher/${teacherID}`)
      // console.log(data);
      this.teacher_data = data.data
    } catch (error) {
      this.$vs.notify({
        title: 'Error',
        text: error.response.data.msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      }) 
    }
  } 
}

</script>
